import BaseProxy from './Proxy';

export default class SubstoreInternalStockProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/substore/internalstock', parameters);
  }

  actionSubscription(params) {
    return this.submit('post', `${this.endpoint}/action/subscription`, params);
  }

  actionInstance(params) {
    return this.submit('post', `${this.endpoint}/action/instance`, params);
  }
}
